//#region src/mdm_provider.ts
var MdmProvider = /* @__PURE__ */ function(MdmProvider) {
	MdmProvider["SimpleMDM"] = "simple-mdm";
	MdmProvider["EloView"] = "elo-view";
	MdmProvider["Esper"] = "esper";
	MdmProvider["SignageOS"] = "signage-os";
	MdmProvider["ChromeOSFlex"] = "chrome-os-flex";
	MdmProvider["WorkspaceOne"] = "workspace-one";
	return MdmProvider;
}(MdmProvider || {});
//#endregion
export { MdmProvider };

//# sourceMappingURL=mdm_provider.js.map